export type MajorArcanaCard = {
  id: string;
  name: string;
  shortMeaning: string;
  prompt: string;
  affirmation: string;
  articleUrl: string;
  imageUrl: string;
  keywords: string[];
};

export const MAJOR_ARCANA: MajorArcanaCard[] = [
  {
    id: "the-fool",
    name: "The Fool",
    shortMeaning: "New beginnings, openness, and courageous curiosity.",
    prompt: "Where can you take a small leap without needing the whole map?",
    affirmation: "I welcome new beginnings with trust and lightness.",
    articleUrl: "https://divinemarkings.com/the-fool-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Fool-Tarot-Card-Meaning.jpg",
    keywords: ["beginnings", "trust", "risk", "fresh start"],
  },
  {
    id: "the-magician",
    name: "The Magician",
    shortMeaning: "Focused will, skill, and the power to begin.",
    prompt: "What resource do you already have that you're underusing?",
    affirmation: "I transform intention into meaningful action.",
    articleUrl: "https://divinemarkings.com/the-magician-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Magician-Tarot-Card-Meaning-Manifest-Your-Will.jpg",
    keywords: ["manifestation", "skill", "willpower", "confidence"],
  },
  {
    id: "the-high-priestess",
    name: "The High Priestess",
    shortMeaning: "Intuition, inner knowing, and quiet truth.",
    prompt: "What do you sense is true even if you can't explain it yet?",
    affirmation: "I trust my intuition and listen deeply.",
    articleUrl: "https://divinemarkings.com/the-high-priestess-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-High-Priestess-Tarot-Card-Meaning.jpg",
    keywords: ["intuition", "mystery", "inner voice", "wisdom"],
  },
  {
    id: "the-empress",
    name: "The Empress",
    shortMeaning: "Nurturing energy, creativity, and abundant growth.",
    prompt: "What part of your life needs gentle care to flourish?",
    affirmation: "I create and receive abundance with ease.",
    articleUrl: "https://divinemarkings.com/the-empress-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Empress-Tarot-Card-Meaning-Nurture-creative-abundance.jpg",
    keywords: ["nurture", "creativity", "abundance", "comfort"],
  },
  {
    id: "the-emperor",
    name: "The Emperor",
    shortMeaning: "Structure, stability, and grounded authority.",
    prompt: "Where would a clear plan reduce your stress right now?",
    affirmation: "I lead my life with calm strength and clarity.",
    articleUrl: "https://divinemarkings.com/the-emperor-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Emperor-Tarot-Card-Meaning-Lead-with-order-and-might.jpg",
    keywords: ["structure", "leadership", "stability", "boundaries"],
  },
  {
    id: "the-hierophant",
    name: "The Hierophant",
    shortMeaning: "Tradition, mentorship, and shared wisdom.",
    prompt: "What proven path or teacher could support your next step?",
    affirmation: "I learn from wisdom that honors my values.",
    articleUrl: "https://divinemarkings.com/the-hierophant-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Hierophant-Tarot-Card-Meaning-Guide-sacred-tradition.jpg",
    keywords: ["tradition", "guidance", "learning", "values"],
  },
  {
    id: "the-lovers",
    name: "The Lovers",
    shortMeaning: "Meaningful connection and values-based choices.",
    prompt: "What choice aligns most with who you truly are?",
    affirmation: "I choose love and integrity in my connections.",
    articleUrl: "https://divinemarkings.com/the-lovers-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Lovers-Tarot-Card-Meaning-Unite-heart-and-mind.jpg",
    keywords: ["love", "choice", "alignment", "relationship"],
  },
  {
    id: "the-chariot",
    name: "The Chariot",
    shortMeaning: "Determination, momentum, and focused victory.",
    prompt: "What single goal deserves your full, steady push this week?",
    affirmation: "I move forward with discipline and confidence.",
    articleUrl: "https://divinemarkings.com/the-chariot-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Chariot-Tarot-Card-Meaning-Drive-to-Conquer-Challenges-1.jpg",
    keywords: ["determination", "momentum", "focus", "success"],
  },
  {
    id: "strength",
    name: "Strength",
    shortMeaning: "Inner courage, patience, and compassionate power.",
    prompt: "How can you be brave without being harsh with yourself?",
    affirmation: "I meet challenges with calm courage and heart.",
    articleUrl: "https://divinemarkings.com/strength-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/Strength-Tarot-Card-Meaning-Exude-courage-and-inner-power-2.jpg",
    keywords: ["courage", "compassion", "resilience", "patience"],
  },
  {
    id: "the-hermit",
    name: "The Hermit",
    shortMeaning: "Solitude, reflection, and truth-seeking.",
    prompt: "What answer might arrive if you slow down and listen?",
    affirmation: "I honor quiet time to find my clarity.",
    articleUrl: "https://divinemarkings.com/the-hermit-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Hermit-Tarot-Card-Meaning-Seek-wisdom-in-quiet-solitude.jpg",
    keywords: ["reflection", "solitude", "wisdom", "inner guidance"],
  },
  {
    id: "the-wheel-of-fortune",
    name: "Wheel of Fortune",
    shortMeaning: "Cycles, change, and turning points.",
    prompt: "What is shifting that you can meet with flexibility?",
    affirmation: "I flow with change and trust lifes timing.",
    articleUrl: "https://divinemarkings.com/the-wheel-of-fortune-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Wheel-of-Fortune-Tarot-Card-Meaning-Embrace-Fate.jpg",
    keywords: ["change", "cycles", "luck", "timing"],
  },
  {
    id: "justice",
    name: "Justice",
    shortMeaning: "Truth, balance, and clear-eyed accountability.",
    prompt: "What would the fairest outcome look like for everyone involved?",
    affirmation: "I act with honesty, balance, and wisdom.",
    articleUrl: "https://divinemarkings.com/justice-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/Justice-Tarot-Card-Meaning-Uphold-fairness-and-truth-1.jpg",
    keywords: ["truth", "balance", "fairness", "integrity"],
  },
  {
    id: "the-hanged-man",
    name: "The Hanged Man",
    shortMeaning: "Pause, surrender, and a new perspective.",
    prompt: "What if waiting is part of the solution, not a delay?",
    affirmation: "I allow space for insight to emerge.",
    articleUrl: "https://divinemarkings.com/the-hanged-man-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Hanged-Man-Tarot-Card-Meaning-Find-Release-in-Surrender-1.jpg",
    keywords: ["pause", "perspective", "surrender", "patience"],
  },
  {
    id: "death",
    name: "Death",
    shortMeaning: "Endings that clear the way for renewal.",
    prompt: "What is ready to be released so something better can begin?",
    affirmation: "I let go with grace and welcome transformation.",
    articleUrl: "https://divinemarkings.com/death-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/Death-Tarot-Card-Meaning-Transform-with-vital-endings.jpg",
    keywords: ["transformation", "endings", "rebirth", "release"],
  },
  {
    id: "temperance",
    name: "Temperance",
    shortMeaning: "Balance, healing, and steady integration.",
    prompt: "Where can you choose the middle path today?",
    affirmation: "I create harmony through patience and care.",
    articleUrl: "https://divinemarkings.com/temperance-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/Temperance-Tarot-Card-Meaning.jpg",
    keywords: ["balance", "healing", "moderation", "alignment"],
  },
  {
    id: "the-devil",
    name: "The Devil",
    shortMeaning: "Attachments, temptation, and reclaiming power.",
    prompt: "What habit or fear is louder than your true self?",
    affirmation: "I am free to choose what supports my growth.",
    articleUrl: "https://divinemarkings.com/the-devil-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/04/The-Devil-Tarot-Card-Meaning-Break-Free-from-Inner-Chains.jpg",
    keywords: ["attachment", "shadow", "freedom", "empowerment"],
  },
  {
    id: "the-tower",
    name: "The Tower",
    shortMeaning: "Sudden change that reveals a truer foundation.",
    prompt: "What truth are you ready to accept even if it disrupts comfort?",
    affirmation: "I rebuild my life on what is real and strong.",
    articleUrl: "https://divinemarkings.com/the-tower-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/05/The-Tower-Tarot-Card-Meaning-Shatter-Illusions-for-Renewal.jpg",
    keywords: ["upheaval", "truth", "breakthrough", "reset"],
  },
  {
    id: "the-star",
    name: "The Star",
    shortMeaning: "Hope, renewal, and gentle faith in the future.",
    prompt: "What small sign of progress can you celebrate today?",
    affirmation: "I am guided by hope and quiet confidence.",
    articleUrl: "https://divinemarkings.com/the-star-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/05/The-Star-Tarot-Card-Meaning-Inspire-Hope-and-Gentle-Healing.jpg",
    keywords: ["hope", "renewal", "calm", "healing"],
  },
  {
    id: "the-moon",
    name: "The Moon",
    shortMeaning: "Mystery, emotions, and trusting your inner compass.",
    prompt: "What feels uncertainand what would help you feel grounded?",
    affirmation: "I navigate uncertainty with intuition and care.",
    articleUrl: "https://divinemarkings.com/the-moon-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/05/The-Moon-Tarot-Card-Meaning-Reveal-Secret-Truths-Tonight.jpg",
    keywords: ["intuition", "uncertainty", "dreams", "emotion"],
  },
  {
    id: "the-sun",
    name: "The Sun",
    shortMeaning: "Joy, clarity, and confident vitality.",
    prompt: "Where can you let yourself be fully seen and celebrated?",
    affirmation: "I welcome joy, clarity, and wholehearted success.",
    articleUrl: "https://divinemarkings.com/the-sun-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/05/The-Sun-Tarot-Card.jpg",
    keywords: ["joy", "success", "clarity", "energy"],
  },
  {
    id: "judgement",
    name: "Judgement",
    shortMeaning: "Awakening, reflection, and answering the call forward.",
    prompt: "What part of your life is asking for a brave new chapter?",
    affirmation: "I rise into my next version with clarity and courage.",
    articleUrl: "https://divinemarkings.com/judgement-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/05/Judgement-Tarot-Card-Meaning-Awaken-to-Your-Inner-Truth-1.jpg",
    keywords: ["awakening", "renewal", "purpose", "forgiveness"],
  },
  {
    id: "the-world",
    name: "The World",
    shortMeaning: "Completion, integration, and deserved celebration.",
    prompt: "What milestone have you earned the right to acknowledge?",
    affirmation: "I honor completion and step forward with wholeness.",
    articleUrl: "https://divinemarkings.com/the-world-tarot-card-meaning/",
    imageUrl: "https://divinemarkings.com/wp-content/uploads/2025/05/The-World-Tarot-Card-Meaning-Embrace-Wholeness-and-Unity.jpg",
    keywords: ["completion", "success", "wholeness", "celebration"],
  },
];
